import type { Book, EditLogEntry } from "../api";
import { useAuth } from "../auth";
import { ErrorNote, Spinner, useLoad } from "../ui";

const TARGET: Record<EditLogEntry["target"], string> = {
  fact: "Feit",
  relation: "Relatie",
  event: "Gebeurtenis",
  entity: "Entiteit",
};
const FIELD: Record<string, string> = {
  verification_status: "status",
  text: "tekst",
  title: "titel",
  description: "beschrijving",
  name: "naam",
  entity_type: "soort",
  hidden: "verborgen",
};

function describe(value: Record<string, unknown> | null): string {
  if (!value) return "";
  return Object.entries(value)
    .map(([k, v]) => `${FIELD[k] ?? k}: ${typeof v === "string" ? v : JSON.stringify(v)}`)
    .join("; ");
}

export function HistoryPanel({ book }: { book: Book }) {
  const { api } = useAuth();
  const log = useLoad(() => api.editLog(book.id), [api, book.id]);
  if (log.error) return <ErrorNote error={log.error} />;
  if (!log.data) return <Spinner />;
  if (log.data.length === 0) return <p className="muted">Nog geen bewerkingen.</p>;
  return (
    <div className="stack">
      <p className="muted small">
        Elke correctie wordt bewaard. Let op: opnieuw verwerken vervangt de inhoud (dit logboek blijft).
      </p>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Wanneer</th>
              <th>Wat</th>
              <th>Was</th>
              <th>Werd</th>
            </tr>
          </thead>
          <tbody>
            {log.data.map((e) => (
              <tr key={e.id}>
                <td className="small">{e.created_at.slice(0, 16).replace("T", " ")}</td>
                <td>
                  {TARGET[e.target]} #{e.target_id} <span className="muted small">{e.action}</span>
                </td>
                <td className="small muted">{describe(e.old_value)}</td>
                <td className="small">{describe(e.new_value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
